export default __webpack_public_path__ + "static/media/bh8.f141adb3.jpg";